<template>
    <div class="general-config-layout">
        <a-card :bordered="false">
            <h1 class="backstage_title1">{{ $t(`moduleTitles.${$route.meta.title}`) }}</h1>
            <!--基本配置-->
            <div class="basic-config">
                <h4 class="sm-titles">
                    <span>{{ $t("moduleTitles.basicConfig") }}</span>
                </h4>
                <a-form-model>
                    <!--背景音樂-->
                    <!-- <a-row type="flex">
                      <a-col :span="12">
                        <h6>{{$t('descriptions.bgm')}}</h6>
                        <div style="diaplay: inline-block; margin: 10px 0px 5px">
                          <audio :src="basicConfig.bgm" controls="controls">
                            {{ $t("message.audioFaileMessage")}}
                          </audio>
                        </div>
                        <div class="btns-box left">
                          <material-select :type="2" @selected="handleSelectedBgm" />
                          <a-button
                            class="m-l-10"
                            v-if="basicConfig.bgm != ''"
                            type="danger"
                            @click="deleteSelectedBgm"
                            >{{$t('actionTitles.delete')}}</a-button
                          >
                        </div>
                      </a-col>
                      <a-col :span="12">
                        <div class="basic-config-checkbox">
                          <div>
                            <a-checkbox
                              @change="
                                (value) => {
                                  this.changeBasicConfig(value, 'edit_bgm');
                                }
                              "
                              :checked="Boolean(basicConfig.edit_bgm)"
                            ></a-checkbox>
                            <span class="item-permission">{{$t('actionTitles.enableModify')}}</span>
                          </div>
                        </div>
                      </a-col>
                    </a-row>
                    <a-divider /> -->
                    <!--封面-->
                    <a-row type="flex">
                        <a-col :span="5">
                            <div class="config-img-box">
                                <AdsItem :is-backstage="true" :url="basicConfig.cover_pc" requireSize="1920 x 1080"
                                    :title="$t('enum.covers.2')" @updateData="handleSelectedPcCover"
                                    @deleteData="deleteSelectedPcCover" width="180px"></AdsItem>
                            </div>
                        </a-col>

                        <a-col :span="6" :offset="2">
                            <div class="config-img-box">
                                <AdsItem :is-backstage="true" :url="basicConfig.cover_mob" requireSize="480 X 800"
                                    :title="$t('enum.covers.3')" @updateData="handleSelectedMobileCover"
                                    @deleteData="deleteSelectedMobileCover" width="180px"></AdsItem>
                            </div>
                        </a-col>

                        <a-col :flex="1" :offset="3">
                            <div class="basic-config-checkbox">
                                <div>
                                    <a-checkbox @change="(value) => {
                                            this.changeBasicConfig(value, 'edit_cover');
                                        }
                                        " :checked="Boolean(basicConfig.edit_cover)"></a-checkbox>
                                    <span class="item-permission">{{ $t('actionTitles.enableModify') }}</span>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                    <a-divider />
                    <!--公司logo和作者信息-->
                    <a-row type="flex">
                        <a-col :span="5">
                            <div class="config-img-box">
                                <AdsItem :is-backstage="true" :url="basicConfig.logo" requireSize="200 x 200"
                                    :title="$t('edit.settings.companyLogo')" @updateData="handleSelectedLogo"
                                    @deleteData="deleteSelectedLogo" width="180px"></AdsItem>
                            </div>
                        </a-col>

                        <a-col :span="6" :offset="2">
                            <ads-item :is-backstage="true" :inputValue="basicConfig.author"
                                @updateData="handleSelectedAuthor" frame-type="input" :title="$t('edit.settings.authName')"
                                width="100%"></ads-item>
                        </a-col>

                        <a-col :flex="1" :offset="3">
                            <div class="basic-config-checkbox">
                                <div>
                                    <a-checkbox @change="(value) => {
                                            this.changeBasicConfig(value, 'edit_logo_fix');
                                        }
                                        " :checked="Boolean(basicConfig.edit_logo_fix)"></a-checkbox>
                                    <span class="item-permission">{{ $t('actionTitles.enableModify') }}</span>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                    <a-divider />
                    <!--滾動文字-->
                    <a-row type="flex">
                        <a-col :span="16">
                            <div class="config-img-box">
                                <ads-item :is-backstage="true" :inputValue="basicConfig.top_ad"
                                    @updateData="handleSelectedTopAd" frame-type="textarea"
                                    :title="$t('edit.settings.scrollTxt')" width="100%"></ads-item>
                            </div>
                        </a-col>
                        <a-col :span="8">
                            <div class="basic-config-checkbox">
                                <div>
                                    <a-checkbox @change="(value) => {
                                            this.changeBasicConfig(value, 'edit_top_ad');
                                        }
                                        " :checked="Boolean(basicConfig.edit_top_ad)"></a-checkbox>
                                    <span class="item-permission">{{ $t('actionTitles.enableModify') }}</span>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </a-form-model>
            </div>
            <!--選單配置-->
            <div class="menu-config">
                <h4 class="sm-titles"><span>{{ $t('edit.editActionTitles.menuSets') }}</span></h4>
                <a-form-model layout="vertical">
                    <div v-if="basicConfig.menus.length">
                        <!--<menu-list
                                v-for="(item, index) in basicConfig.menus"
                                :key="index"
                                :selectOptions="selectOptions"
                                :item="item"
                                :index="index"
                                @del="delMenu"
                                @changSource="changSource"
                        ></menu-list>-->
                        <Menu-item v-for="(item, index) in basicConfig.menus" :key="index" :selectOptions="selectOptions"
                            :item="item" :is-backstage="true" @del="delMenu" @changSource="changSource"></Menu-item>
                    </div>
                    <div class="menu-config-menubtn">
                        <a style="color: #000" @click.stop="addMenu">+ {{ $t('edit.addMenu') }}</a>
                    </div>
                </a-form-model>
            </div>
            <!--提交按鈕-->
            <footer class="ant-modal-footer">
                <div>
                    <button type="button" class="ant-btn ant-btn-primary" @click="onSubmit">
                        <span>{{ $t("actionTitles.submit") }}</span>
                    </button>
                </div>
            </footer>
        </a-card>

        <a-modal :closable="false" :cancelText="''" v-model="saveVisible" @ok="onSave">
            <template slot="footer">
                <a-button type="primary" :loading="loading" @click="onSave">
                    {{ $t("actionTitles.confirm") }}
                </a-button>
            </template>
            <a-radio-group v-model="updateChild">
                <a-radio :value="false">{{ $t('actionTitles.applyNew') }}</a-radio>
                <a-radio :value="true">{{ $t('actionTitles.applyAll') }}</a-radio>
            </a-radio-group>
        </a-modal>
    </div>
</template>
<script>
// import MenuList from "./MenuList";
import MaterialSelect from "@/components/MaterialSelect";
import { saveUserConfig, getUserConfig } from "@/api/generalConfig";

import AdsItem from "../../../edit/component/setting/component/AdsItem";
import MenuItem from "../../../edit/component/setting/component/MenuItem";

export default {
    name: "GeneralConfig",
    props: {
        id: {
            // 單獨配置傳該用戶id的 通用配置傳當前登錄者id
            type: Number,
            require: true,
        },
        userType: {
            type: Number,
            default: 1,
        },
    },
    components: { AdsItem, MenuItem, MaterialSelect },
    data() {
        return {
            basicConfig: {
                uid: this.id,
                author: '',
                bgm: "",
                edit_bgm: 0,
                logo: "",
                fix_logo_land: "",
                edit_logo_fix: 0,
                cover_pc: "",
                cover_mob: "",
                edit_cover: 0,
                top_ad: "",
                edit_top_ad: "",
                menus: [],
            },
            selectOptions: [
                { id: 1, value: 1, title: this.$t("edit.link"), disabled: false },
                { id: 2, value: 2, title: this.$t("edit.phone"), disabled: false },
                { id: 3, value: 3, title: this.$t("edit.mapAddress"), disabled: false },
                { id: 4, value: 4, title: this.$t("edit.picText"), disabled: false },
                { id: 5, value: 5, title: this.$t("edit.video"), disabled: false },
            ],
            menuIndex: 0,
            saveVisible: false,
            updateChild: false,
            loading: false
        };
    },
    mounted() {
        this.init();
    },
    updated() {
    },
    methods: {
        init() {
            getUserConfig({ uid: this.id })
                .then((res) => {
                    if (res.code === 1 && res.data) {
                        this.basicConfig = res.data;
                        if (this.basicConfig.menus.length) {
                            this.basicConfig.menus.forEach((item) => {
                                this.menuIndex++;
                                item.num = this.menuIndex;
                            });
                        }
                    }
                })
                .catch(() => {
                });
        },
        changSource(item) {
            // this.basicConfig.menus[i] = item;
            const num = item.num;
            this.basicConfig.menus.forEach((v, i) => {
                if (v.num === num) {
                    this.$set(this.basicConfig.menus, i, {
                        ...item,
                    });
                }
            });
        },
        delMenu(num) {
            // this.basicConfig.menus.splice(index, 1);
            let index = null;
            this.basicConfig.menus.find((v, i, arr) => {
                if (v.num === num) {
                    index = i;
                    return;
                }
            });
            this.basicConfig.menus.splice(index, 1);
            const length = this.basicConfig.menus.length;
            if (length > 0) {
                this.menuIndex = length;
            } else {
                this.menuIndex = 0;
            }
        },
        addMenu() {
            this.menuIndex++;
            this.basicConfig.menus = [
                ...this.basicConfig.menus,
                {
                    num: this.menuIndex,
                    title: "",
                    type: null,
                    table_type: "menu",
                    is_edit: 0,
                    uid: this.id,
                },
            ];
        },
        changeBasicConfig(e, option) {
            this.basicConfig[option] = Number(e.target.checked);
        },
        onSubmit() {
            this.updateChild = false;
            if (this.userType == 2) {
                this.saveVisible = true;
            } else {
                this.onSave();
            }
        },
        onSave() {
            this.loading = true;
            saveUserConfig({
                config: this.basicConfig,
                updateChild: this.updateChild,
            })
                .then((res) => {
                    this.loading = false;
                    this.saveVisible = false;
                    if (res.code === 1) {
                        this.$message.success(this.$t("message.saveSuccess"));
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        onCancel() { },
        handleSelectedBgm(item) {
            this.basicConfig.bgm = item.url;
        },
        deleteSelectedBgm() {
            this.basicConfig.bgm = "";
        },
        handleSelectedLandmark(item) {
            this.basicConfig.fix_logo_land = item.url;
        },
        deleteSelectedLandmark() {
            this.basicConfig.fix_logo_land = "";
        },
        handleSelectedLogo(item) {
            this.basicConfig.logo = item.url;
        },
        deleteSelectedLogo() {
            this.basicConfig.logo = "";
        },
        handleSelectedAuthor(data) {
            this.basicConfig.author = data
        },
        handleSelectedTopAd(data) {
            this.basicConfig.top_ad = data
        },
        handleSelectedPcCover(item) {
            this.basicConfig.cover_pc = item.url;
        },
        deleteSelectedPcCover() {
            this.basicConfig.cover_pc = "";
        },
        handleSelectedMobileCover(item) {
            this.basicConfig.cover_mob = item.url;
        },
        deleteSelectedMobileCover() {
            this.basicConfig.cover_mob = "";
        },
    },
};
</script>

<style lang="less" scoped>
.sm-titles {
    font-size: 15px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 20px;

    span {
        display: inline-block;
        height: 100%;
        padding-bottom: 10px;
        border-bottom: 2px solid #0a67fb;
    }
}

.btns-box {
    display: flex;
    align-items: center;
    justify-content: center;

    &.left {
        justify-content: flex-start;
    }

    .m-l-10 {
        margin-left: 10px;
    }
}

.tips {
    font-size: 12px;
    color: #aaaaaa;
    margin-bottom: 10px;
}

.config-img-box {
    display: flex;
    justify-content: center;
}

.menu-config {
    padding-bottom: 0;
}
</style>
